import React from 'react';
import { TextField } from '@framework-controls/core';
import css from './InformationCard.module.scss';
import { strings } from 'src/localization';
interface IProps {
    id: string;
    label: string;
    value: string;
    error: boolean;
    onChange: (id: string, value: string) => void;
    onBlur: (id: string) => void;
    disabled: boolean;
    getFieldRef?: (el: HTMLElement) => void;
    theme: string;
}

/** Renders a labeled text field for customer info (name, phone, email, mileage) with error helper text. */
const InformationCardField = (props: IProps) => {
    let inputClass = css.Input;
    if (props.disabled) {
        inputClass = props.theme === 'cadillac' ? css.InputDisabledCadillac : css.InputDisabled;
    }

    let helperText = '';
    if (props.error) {
        if (props.id === 'phoneNumber') {
            helperText = strings.ValidPhone;
        } else if (props.id === 'emailAddress') {
            helperText = props.value?.length > 62 ? strings.ValidEmailLength : strings.ValidEmail;
        } else if (props.id === 'firstName' || props.id === 'lastName') {
            helperText = props.value?.length === 0 ?
                strings.formatString(strings.EmptyNameError, props.label).toString() :
                strings.ValidNameLength;
        } else {
            helperText = strings.formatString(strings.EmptyNameError, props.label).toString();
        }
    }

    const blurHandler = () => props.onBlur(props.id);

    return (
        <div className={inputClass}>
            <TextField
                id={props.id}
                label={`${props.label} *`}
                value={props.value ? props.value : ''}
                size='full'
                type='text'
                error={props.error}
                onChange={props.onChange}
                onBlur={blurHandler}
                helperText={helperText}
                disabled={props.disabled}
                getFieldRef={props.getFieldRef}
            />
        </div>
    );
};

export default InformationCardField;
